var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 90,
    viewBox: "0 0 99 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2036 17.941L50.1471 50.6736L85.3053 47.6382",
    stroke: "#263238",
    strokeWidth: 2.3576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2023 25.4661C54.1765 27.6341 49.0608 26.1651 46.7775 22.1799C44.4943 18.1947 45.911 13.2078 49.9368 11.0398C53.9626 8.87176 59.0782 10.3408 61.3615 14.326C63.6448 18.3111 62.2281 23.2981 58.2023 25.4661Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9675 25.0194C52.3721 25.019 49.8357 23.6586 48.467 21.2699",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0855 56.5097C84.3053 59.084 78.2316 57.3395 75.5209 52.6083C72.8102 47.8771 74.4919 41.956 79.2721 39.3818C84.0522 36.8075 90.1259 38.552 92.8366 43.2832C95.5474 48.0144 93.8656 53.9355 89.0855 56.5097Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0965 55.9804C82.0445 55.9762 79.0634 54.386 77.4499 51.5698",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5817 80.4676C29.5617 82.094 25.7234 80.9922 24.01 78.0018C22.2966 75.0113 23.36 71.2699 26.38 69.6435C29.4 68.0171 33.2383 69.1189 34.9517 72.1093C36.665 75.0998 35.6016 78.8413 32.5817 80.4676Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3487 80.1306C28.3683 80.1286 26.4248 79.098 25.3753 77.2664",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4635 60.0079C51.5539 63.1903 44.0459 61.0334 40.6952 55.1853C37.3446 49.3372 39.4231 42.0176 45.3326 38.8351C51.2421 35.6526 58.7502 37.8095 62.1008 43.6577C65.4515 49.5058 63.373 56.8254 57.4635 60.0079Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3403 59.35C48.6019 59.346 44.9465 57.3898 42.9745 53.9479",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.d239c1f8c3d2d169ac507f8a5dd483c5.svg";
export { ForwardRef as ReactComponent };